"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Badge = {
    sizes: {
        md: {
            borderRadius: 'md',
            fontSize: 'md',
            paddingBlock: 1,
            paddingInline: 2,
        },
    },
};
exports.default = Badge;
